var exports = {
  "Cw": "xf0b3b88a--cf3514--agent-section",
  "my": "xf0b3b88a--cf3514--avatar",
  "UU": "xf0b3b88a--cf3514--name",
  "iW": "xf0b3b88a--cf3514--company-name",
  "Il": "xf0b3b88a--cf3514--text-badge",
  "wL": "xf0b3b88a--cf3514--green",
  "qS": "xf0b3b88a--cf3514--badge",
  "cs": "xf0b3b88a--cf3514--badge-container",
  "Rx": "xf0b3b88a--cf3514--other-offers",
  "fB": "xf0b3b88a--cf3514--user-info",
  "Gv": "xf0b3b88a--cf3514--user-info-action",
};

module.exports = exports;
